import React from 'react'
import Swal from 'sweetalert2'
import { GrCertificate, GrClose, GrFolderCycle } from 'react-icons/gr'

import Wizard from '@modules/form-wizard'
import toastr from '@modules/toastr'
import { fullName } from '@modules/form-wizard/utils'
import { listKeys } from '@helpers/objects'
import SERVICE_PROPS from '@helpers/extract-service-props'
import occupations from '@constants/occupations'
import countries from '@constants/countries'
import islands from '@constants/islands'

import passportPhotoExample from '@helpers/passport-photo-example'
import { ItemCriminalHistory } from './police_criminal_history_list'
import Modal from 'react-responsive-modal'
import Loader from '@shared/loader'
import moment from 'moment'

export default class CharacterReference extends React.Component {
  state = {
    loading: false,
    record: null,
    photo_upload: null,
    criminal_history: [],
    showTerms: false,
  }

  title = 'Character Certificate (Digital)'
  resource = '/police_certificates'
  form_key = 'police_certificate'

  hide_buttons  = {
    status: true,
    deny: false,
  }

  defaults = {
    digital_cert_only: true,
    physical_copy: false,
  }

  read_params = {
    admin: true,
    label: ' ',
    default: 'Default',
    values: {
      'Default': {
        digital_cert_only: true,
        physical_copy: false
      },
    },
  }

  // skip_location = form => form.delivery_method == 'DIGITAL'
  skip_location = true
  custom_acceptance = true

  get isBahamian() {
    return $app.applicant?.country_of_citizenship == 'bahamas'
  }

  defaults = () => {
    const res = {
      full_name: fullName($app.applicant),
      amount: 1,
    }

    if (this.isBahamian) {
      res.birth_place = 'Bahamas'
      res.passport_issue_country = 'Bahamas'
    }

    return res
  }

  showPassort = (form) => {
    if (this.isBahamian) {
      if (form.travel_job != 'Travel') {
        return true
      }
    } else {
      return false
    }
  }

  checkPassportAPI = async (form) => {
    this.setState({ loading: true });
    const passport_numb = form.passport_number
    const nib = $app.applicant.NIB

    if (passport_numb.trim().length < 7) {
      this.setState({ loading: false });
      return toastr.error('Error', 'Please enter a valid passport number');
    }

    try {
      const data = await $app.axios.get(
        `${process.env.REACT_APP_API_HOST}/api/v1/admin/passport_photo?nib=${nib}&passport_numb=${passport_numb}`
      )

      if (data?.data?.status) {
        const photo = 'data:image/png;base64,' + data?.data?.base64_string
        this.setState({ photo_upload: photo });
        console.log('photo found', photo)

        return true
      } else {
        toastr.error('Error', 'No photo found for this passport number. Please be sure to enter the correct passport number and that your passport is valid.');
        return false
      }
    } catch (err) {
      if (process.env.NODE_ENV === 'development') console.log(err);
      // dispatch(errorLog(err?.response?.data?.error));
    } finally {
      this.setState({ loading: false });
      return false
    }
  }

  canned = [
    `
    Thank you for your request. We require that you come in person for a finger print scanning.
    Please visit the Royal Bahamas Police Force Head Office at New Providence, Thompson Blvd. to complete your application process
    `,
  ]

  /* The `fee` function is calculating the fee for the service based on the form data. It takes in the
  `form` object as a parameter and returns a number representing the fee. */
  fee = form => {
    const rate = $app.applicant.verified_citizenship ? 5 : 10
    return rate

    // Below code is only needed once multiple copies can be requested
    // if (form.delivery_method == 'DIGITAL') return rate

    // // if the delivery amount is BOTH, the
    // // digital amount will be added to the total before
    // // multiplication of amount requested
    // let amount = form.delivery_method == 'PHYSICAL' ? 0 : rate
    // return amount + (rate * form.copies_requested)
  }

  custom_actions = [
    {
      text: 'Criminal History',
      icon: 'user-tie',
      roles: [['officer']],
      test: r =>
        r.payment_status &&
        ['pending', 'officer viewed', 'finger print', 'processing'].includes(r.application_decision),
      fn: record => this.setState({ record }),
    },
    {
      text: 'Request Prints',
      icon: 'fingerprint',
      fn: async record => {
        const person = listKeys(
          record.user,
          'first_name',
          'middle_name',
          'last_name'
        )
          .filter(n => n)
          .join(' ')
          .capitalize()

        const { isConfirmed } = await Swal.fire({
          icon: 'question',
          title: 'Request Fingerprints',
          text: `Are you sure want to request that ${person} come in for fingerprinting?`,
          showCancelButton: true,
        })

        if (isConfirmed) {
          const { resource, form_key } = this
          this.setState({ loading: true })

          try {
            await $app.axios.put(resource + '/update_application', {
              [form_key]: {
                form_num: record.form_num,
                application_decision: 'finger print',
                finger_print_rq: true,
              },
            })

            await $app.axios.post('/emails', {
              email: record.user.email,
              subject: 'MyGateqway Portal Update - Character Reference Request',
              message: `
                Good day ${record.user.first_name.capitalize()},
                <br/>
                In order to complete your Character Reference request, we ask that you
                come in person to the Central Detective Unit located on Thompson Blvd.,
                New Providence for fingerprinting.
                <br/><br />
                Thank you for using MyGateway Portal.
              `,
            })
          } catch (err) {
            console.error(err)
          } finally {
            this.setState({ loading: false })
          }
        }
      },
    },
    {
      text: 'Mark as Processing',
      icon: <GrFolderCycle className='text-blue-600' />,
      roles: ['officer'],
      test: r => r.digital_cert_only && r.payment_status && ['pending'].includes(r.application_decision),
      fn: async record => {
        const { isConfirmed } = await Swal.fire({
          icon: 'question',
          title: 'Set as Processing',
          html: `
            Set the application status as processing for,
            <strong>${fullName(record.user, 'initial')}</strong>?
          `,
          showCancelButton: true,
        })

        if (isConfirmed) {
          this.setState({ loading: true })

          const { props, resource, form_key } = this
          const { history, location } = props
  
          try {
            await $app.axios.put(resource + '/update_application', {
              [form_key]: {
                form_num: record.form_num,
                application_decision: 'processing',
              },
            })
  
            if (location.state?.view) {
              const view = { ...location.state.view }
              view.application_decision = 'processing'
  
              history.replace(location.pathname, { ...location.state, view })
            }
  
            toastr.success('Success', 'Application processed')
          } catch (error) {
            console.error(error)
            toastr.error('Error', 'Unable to process application')
            return
          }
  
          this.setState({ loading: false, record: null })
        }
      }
    },
    {
      text: 'Approve Digital Print',
      icon: <GrCertificate className='text-blue-600' />,
      roles: ['officer'],
      test: r => r.digital_cert_only && r.payment_status && ['pending', 'finger print', 'processing'].includes(r.application_decision),
      fn: async record => {
        const { isDismissed } = await Swal.fire({
          title: 'Approve Digital Print',
          // input: 'text',
          // inputLabel: 'Tag Number',
          // inputPlaceholder: 'Tag Number',
          html: `Are you sure you want to approve the digital certificate for
          <strong>${fullName(record.user, 'initial')}</strong>?`,
          showCancelButton: true,
          confirmButtonText: 'Approve',
        })

        if (isDismissed) return
        this.setState({ loading: true })

        const { props, resource, form_key } = this
        const { history, location } = props

        try {
          await $app.axios.put(resource + '/update_application', {
            [form_key]: {
              form_num: record.form_num,
              application_decision: 'approved',
            },
          })

          if (location.state?.view) {
            const view = { ...location.state.view }
            view.application_decision = 'approved'

            history.replace(location.pathname, { ...location.state, view })
          }

          toastr.success('Success', 'Application print processed and sent for final approval')
        } catch (error) {
          console.error(error)
          toastr.error('Error', 'Unable to approve license')
          return
        }

        this.setState({ loading: false, record: null })
      }
    },
    {
      text: 'Process Digital Print',
      icon: <GrCertificate className='text-blue-600' />,
      roles: [['senior_officer', 'director']],
      test: r => r.digital_cert_only && r.payment_status && ['officer viewed', 'senior officer viewed'].includes(r.application_decision),
      fn: async record => {
        const isFinalApprover = true // $app.hasAnyRole(['director']);

        const { value, isDismissed } = await Swal.fire({
          title: 'Process Application',
          html: `
            What is your recommendation regarding the applicant,
            <strong>${fullName(record.user, 'initial')}</strong>?
          `,
          input: 'select',
          inputOptions: {
            'approved': isFinalApprover ? "I approve this applicant" : "I recommend this applicant",
            'denied': isFinalApprover ? "I will deny this applicant" : "I do not recommend this applicant",
          },
          showCancelButton: true,
          confirmButtonText: 'Send',
        })

        if (isDismissed) return
        this.setState({ loading: true })

        const { props, resource, form_key } = this
        const { history, location } = props

        try {
          await $app.axios.put(resource + '/update_application', {
            [form_key]: {
              form_num: record.form_num,
              application_decision: value,
            },
          })

          if (location.state?.view) {
            const view = { ...location.state.view }
            view.application_decision = isFinalApprover ? value : 'senior officer viewed'

            history.replace(location.pathname, { ...location.state, view })
          }

          toastr.success('Success', 'Application processed')
        } catch (error) {
          console.error(error)
          toastr.error('Error', 'Unable to process application')
          return
        }

        this.setState({ loading: false, record: null })
      }
    },
    {
      text: 'Recall Certificate',
      icon: <GrClose className='text-blue-600' />,
      roles: [['senior_officer', 'director']],
      test: r => r.digital_cert_only && r.payment_status && ['approved'].includes(r.application_decision),
      fn: async record => {
        const { isConfirmed } = await Swal.fire({
          icon: 'question',
          title: 'Recall Certificate',
          html: `
            Deny an approved certificate,
            <strong>${fullName(record.user, 'initial')}</strong>?
          `,
          showCancelButton: true,
        })

        if (isConfirmed) {
          this.setState({ loading: true })

          const { props, resource, form_key } = this
          const { history, location } = props
  
          try {
            await $app.axios.put(resource + '/update_application', {
              [form_key]: {
                form_num: record.form_num,
                application_decision: 'cancelled',
              },
            })
  
            if (location.state?.view) {
              const view = { ...location.state.view }
              view.application_decision = 'cancelled'
  
              history.replace(location.pathname, { ...location.state, view })
            }
  
            toastr.success('Success', 'Application processed')
          } catch (error) {
            console.error(error)
            toastr.error('Error', 'Unable to process application')
            return
          }
  
          this.setState({ loading: false, record: null })
        }
      }
    },
  ]

  validate = form => {
    const updates = { digital_cert_only: true }

    

    // Below code is only needed once multiple copies can be requested
    // if (form.copies_requested) {
    //   if (form.copies_requested < 1 || form.copies_requested > 10)
    //     return 'For # of copies, please enter an amount between 1 and 10.'
    // }

    // switch (form.delivery_method) {
    //   case 'PHYSICAL':
    //     updates.physical_copy = true
    //     updates.digital_cert_only = false
    //     break
    //   case 'DIGITAL':
    //     updates.digital_cert_only = true
    //     updates.physical_copy = false
    //     break
    //   case 'BOTH':
    //     updates.physical_copy = true
    //     updates.digital_cert_only = true
    //     break
    //   default:
    //     toastr.warning('Response Needed', 'Please select a type of certificate')
    //     return false

    // }

    if (form.full_name.trim().split(' ').length < 3 && !form.no_middle_name) {
      return 'Please be sure to enter your middle name'
    }

    updates.photo_upload = this.state.photo_upload

    return updates
  }

  columns = props => [
    {
      name: 'Type',
      selector: row => {
        let typeList = []
        if (row.digital_cert_only) typeList.push('Digital')
        if (row.physical_copy) typeList.push('Physical')
        if (row.certified_copy) typeList.push('Certified')
        return typeList.join(', ')
      },
      sortable: true,
      searchable: r => r.digital_cert_only || r.physical_copy || r.certified_copy,
    },
    {
      name: 'Recommendation',
      selector: row => {
        const notes = row.notes.filter(n => n.text.includes('issue'))
        // console.log(notes)
        if (notes.length > 0) {
          const bracketIndex = notes[notes.length - 1].text.indexOf('(')
          console.log(bracketIndex)

          return notes[notes.length - 1].text.substring(bracketIndex)
        }
        return 'N/A'
      },
      sortable: true,
      // searchable: r => r.reviewer,
    },
  ]

  showTerms = () => {
    this.setState(prev => ({ showTerms: !prev.showTerms }))
  }

  fields = form => [
    {
      heading: `This form is for a Digital Police Character Certificate only`,
    },
    {
      name: 'criminal_history_list',
      label: 'Criminal History Record',
      columns: [
        // {
        //   name: 'id',
        //   label: 'ID',
        //   is: 'integer',
        //   width: 12,
        //   view: false,
        // },
        {
          name: 'date',
          label: 'Date',
          is: 'date',
          width: 32,
          // view: {
          //   value: v => (v ? moment(v).format('MMMM Do YYYY, h:mm:ss a') : 'N/A')
          // },
        },
        {
          name: 'court',
          label: 'Court',
          // is: 'integer',
          width: 52,
        },
        {
          name: 'conviction',
          label: 'Conviction',
          // is: 'integer',
          width: 74,
        },
        {
          name: 'sentence',
          label: 'Sentence',
          // is: 'integer',
          width: 52,
        },
      ],
      view: {
        format: list => list.map(row => ({
          ...row,
          date: row.date ? moment(row.date).format('MMM/D/YYYY') : 'N/A'
        }))
      },
      hide: true,
    },
    {
      name: 'travel_job',
      label: 'Purpose',
      options: ['Travel', 'Employment', 'Immigration'],
      hint: 'Will this document be used for travel, employment or immigration?',
    },
    {
      name: 'digital_cert_only',
      label: 'Digital Certificate',
      type: 'select:bool',
      hide: true,
      save: true,
      view: true,
    },
    {
      name: 'physical_copy',
      label: 'Physical Copy',
      type: 'select:bool',
      hide: true,
      save: true,
      view: true,
    },
    // {
    //   name: 'delivery_method',
    //   type: 'radio',
    //   view: false,
    //   label: 'Type of Certificate',
    //   options: [
    //     { value: 'DIGITAL', label: 'DIGITAL' },
    //     // { value: 'PHYSICAL', label: 'PHYSICAL' },
    //     { value: 'BOTH', label: 'DIGITAL & CERTIFIED COPY' }
    //   ],
    // },
    // {
    //   name: 'copies_requested',
    //   label: '# of Copies',
    //   type: 'number',
    //   is: 'integer',
    //   min: 1,
    //   hide: form.delivery_method == 'DIGITAL'
    // },
    {
      name: 'passport_verified',
      admin: true,
    },
    'street_address',
    {
      name: 'birth_place',
      label: 'Country Of Birth',
      options: countries,
    },
    {
      name: 'birth_island',
      label: 'Island Of Birth',
      options: islands,
      hide: form.birth_place !== 'Bahamas',
      use_profile: 'island',
    },
    {
      name: 'occupation',
      options: occupations,
    },
    {
      heading: 'Passport Details',
      hide: form.travel_job != 'Travel',
    },
    {
      name: 'passport_number',
      // hide: form.travel_job != 'Travel',
      hint: 'Photo will be pulled from Passport API once a valid passport number is entered',
      onBlur: (ev) => {
        const res = this.checkPassportAPI(form)

        return { photo_upload: res ? this.state.photo_upload : null }
      },
    },
    {
      heading: (
        <div className='row mb-3'>
          <div className='col-lg-3 col-md-3 col-sm-4 text-right '></div>
          <div className='flex flex-col align-items-center'>
            <h6 className='sub font-bold'>Passport Photo Preview</h6>
            {this.state.photo_upload ? <img src={this.state.photo_upload} alt="Passport" className="w-32 h-32 object-cover" /> : 'N/A'}
          </div>
        </div>
      ),
      save: false,
      view: {
        element: (v, f) => {
          return null
        }
      }
    },
    {
      name: 'full_name',
      hint: "Enter the full name on your passport if it's not the same as your NIB",
      save: true,
      view: !!form.full_name,
      required: !form.no_middle_name,
      disabled: form.no_middle_name,
    },
    {
      name: 'no_middle_name',
      view: false,
      type: 'checkbox',
      label: 'I have no middle name',
      required: false,
    },
    {
      name: 'passport_issue_date',
      label: 'Issue Date',
      type: 'date',
      showMonthDropdown: true,
      showYearDropdown: true,
      hide: form.travel_job != 'Travel',
    },
    {
      name: 'passport_expiry_date',
      label: 'Expiration Date',
      type: 'date',
      showMonthDropdown: true,
      showYearDropdown: true,
      hide: form.travel_job != 'Travel',
    },
    {
      name: 'identification',
      type: 'file:image',
      label: 'Identification',
      key: f => f.image[0],
      hide: this.showPassort(form),
      tooltip: 'Only the information page is required',
      hint: passportPhotoExample,
    },
    {
      name: 'passport_issue_country',
      label: 'Issuing Country',
      hide: form.travel_job != 'Travel',
      disabled: this.isBahamian,
      options: countries,
    },
    {
      name: 'work_permit_upload',
      label: 'Work Permit',
      type: 'file:image',
      key: f => f.image[1],
      hide: this.isBahamian,
    },
    {
      name: 'photo_upload',
      type: 'file:image',
      disabled: true,
      save: true,
      hide: true,
      view: true,
      label: 'Self Portrait',
      key: f => f.image[2],
      // tooltip: 'A recent high quality headshot self portrait',
      hint: 'Photo will be pulled from Passport API once a valid passport number is entered',
      // hint: passportPhotoExample,
      required: false
    },
    {
      name: 'acceptance_passport_consent',
      label: `I consent to the Royal Bahamas Police Force (“RBPF”) retrieving my photograph
        from The Bahamas’ Passport Office for verification purposes related to the Digital
        Police Character Certificate.`,
      type: 'checkbox',
      required: true,
    },
    {
      name: 'acceptance_photo_consent',
      label: `I consent to my passport photograph being included on my Digital Police Character
        Certificate.`,
      type: 'checkbox',
      required: true,
    },
    {
      use_as_acceptance: true,
      name: 'acceptance',
      label: `I confirm that I have read and agree to the terms in the expanded section below.`,
      type: 'checkbox',
      required: true,
    },

    {
      heading: (
        <div className='flex flex-col align-items-center'>
        <div className='mt-4' style={{maxWidth: '800px'}}>
          <h3>Third-Party Use Disclaimer:</h3>
          <p>
            The RBPF accepts no responsibility for the use, storage, or processing of any personal
            data contained in the Digital Police Character Certificate, including passport photographs,
            once it has been shared with a third party by the applicant or on the applicant's behalf.
          </p>

          { !this.state.showTerms && (
            <button
              type='button'
              className='btn btn-link p-0 mt-2 mb-4'
              onClick={() => this.showTerms()}
            >
              (Click To Expand for Terms and Conditions)
            </button>
          )}
          { this.state.showTerms && (
            <div>
              <h5 className='font-bold'>
                CONSENT FOR THE TRANSFER AND COLLECTION OF PHOTOGRAPHIC
                PERSONAL DATA FOR A DIGITAL CHARACTER CERTIFICATE
              </h5>
              
              <p>
                <b>Purpose of Collection and Transfer:</b> This consent authorizes the collection and secure
                transfer of my personal data, which shall be limited to my passport photograph between
                agencies of the government of the Commonwealth of The Bahamas, namely, The
                Bahamas Passport Office, a department of the Ministry of Foreign Affairs and the Royal
                Bahamas Police Force. The sole purpose for the transfer of my passport photograph shall
                be for the application and granting of a Digital Police Character Certificate as provided for
                under the <b>Legal Authority</b> and <b>Scope of Consent</b> sections set out below.
              </p>
              
              <p>
                <b>Legal Authority:</b> This process is in accordance with The Police Force Act (Ch. 205) and
                aligned with the principles of The Bahamas’ data protection laws and international best
                practices.
              </p>

              <p>
                <b>Scope of Consent:</b> By signing below, I voluntarily consent to:
                <br/>
                <ol style={{ listStyleType: ')' }}>
                  <li>
                    The transfer of my passport photograph from The Bahamas’ Passport Office to the
                    RBPF.
                  </li>
                  <li>
                    The use of my passport photograph for the application for and the issuance of a
                    digital Police Character Certificate.
                  </li>
                </ol>
              </p>

              <p>
                <b>Privacy and Protection Measures:</b>
                <br/>
                <ol style={{ listStyleType: ')' }}>
                  <li>
                    My passport photograph will be handled in accordance with applicable data
                    protection laws.
                  </li>
                  <li>
                    Access will be limited to authorized personnel and used solely for official purposes.
                  </li>
                  <li>
                    I understand I may withdraw consent for the use of my passport photograph
                    subject to legal conditions.
                  </li>
                </ol>
              </p>

              <button
                type='button'
                className='btn btn-link p-0 mt-2 mb-4'
                onClick={() => this.showTerms()}
              >
                (Click To Collapse Terms and Conditions)
              </button>
            </div>
          )}
        </div>
        </div>
      ),
      view: false,
    }
  ]

  hidden_fields = form => [
    {
      key: 'image.3',
      name: 'pdf_upload',
      type: 'file:pdf',
      label: 'Character Certificate (Summary)',
      hide: !form.digital_cert_only,
    },
    {
      key: 'image.4',
      name: 'pdf_upload_2',
      type: 'file:pdf',
      label: 'Character Certificate (Full)',
      hide: !form.digital_cert_only,
    }
  ]

  closeModal = ev => {
    ev && ev.preventDefault()
    this.setState({ record: null })
  }

  stringifyJSON = json => json.map(j => JSON.stringify(j))

  saveHistorySubmit = async approvedState => {
  this.setState({ loading: true })
    const { resource, form_key, props, stringifyJSON } = this
    const { history, location } = props
    const { axios } = $app
    const { record } = this.state

    // const tables = Object.keys(approvedState)

    // const stringifyState = tables.reduce((obj, val) => {
    //   obj[val] = Array.isArray(approvedState[val])
    //     ? stringifyJSON(approvedState[val])
    //     : approvedState[val]
    //   return obj
    // }, {})

    // return console.log(stringifyJSON(approvedState));


    try {
      await axios.put(resource + '/update_criminal_history', {
        [form_key]: {
          form_num: record.form_num,
          criminal_history_list: stringifyJSON(approvedState),
        },
      })

      if (location?.state?.view) {
        const view = { ...location.state.view }
        // const fields = [...view.fields].map(f => {
        //   return tables.includes(f.name)
        //     ? {
        //         ...f,
        //         value: approvedState[f.name],
        //       }
        //     : f
        // })

        // view.fields = fields

        history.replace(location.pathname, {
          ...location.state,
          view,
        })
      }

      Swal.fire(
        'Submitted!',
        'Criminal History Records sucessfully updated.',
        'success'
      ).then(() => window.location.reload())
    } catch (error) {
      console.error(error)
      Swal.fire(
        'Oops..',
        'Something went wrong with trying to submit this application for final approval',
        'error'
      )
      return
    }

    this.setState({ loading: false, record: null })
  }

  render () {
    const {
      state,
      props,
      closeModal,
      fields,
      resource,
      form_key,
      update,
      saveHistorySubmit,
    } = this
    const { record, loading } = state

    const fprops = {
      update,
      resource,
      closeModal,
      form_key,
      location: props.location,
      history: props.history,
      submit: saveHistorySubmit,
    }

    if (record) {
      Object.assign(fprops, {
        record,
        fields: fields(record),
        tableName: `${record.user.first_name} ${record.user.no_middle_name || ''} ${record.user.last_name}`,
      })
    }

    return (
      <React.Fragment>
        <Loader loading={loading} />
        <Wizard {...SERVICE_PROPS(this)} />
        <Modal
          open={!!record}
          onClose={closeModal}
          center
          styles={{ modal: { maxWidth: '1920px', width: '90%', position: 'relative' } }}
        >
          {fprops?.record && <ItemCriminalHistory record={record} fields={fprops['fields']} submit={fprops['submit']} closeModal={fprops['closeModal']} tableName={fprops['tableName']} />}
        </Modal>
      </React.Fragment>
    )
  }
}
